import axios from "axios";
import { Location } from "../types";

async function coordinates(
  placeId: string,
  sessionToken: string
): Promise<Location> {
  const response = await axios.get<Location>("/api/google_maps/coordinates", {
    params: { place_id: placeId, session_token: sessionToken },
  });

  return response.data;
}

export default coordinates;
